import { useTransaction } from "hooks/useTransactions";
import * as i18n from "util/i18n";
import Button from "pages/_components/Button";
import { ResponsiveHeader } from "pages/_components/header";
import Image from "pages/_components/Image";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import React, { useState } from "react";
import { bool } from "prop-types";
import { Col, Row } from "react-bootstrap";
import { actions as refillsActions } from "reducers/refills";
import RefillsSummaryBody from "./refillsSummaryBody";

const RefillsTransactionPage = ({ isDesktop }) => {
    const formatTransactionTransfer = (data, idTransaction) => ({ ...data, idTransaction });

    const { isLoading, transaction, dispatch, handleSignTransaction, showSignButton, push, status } = useTransaction(
        `/Payment/refills/confirm`,
        refillsActions.refillsFormData,
        refillsActions.cleanRefillsTicket,
        formatTransactionTransfer,
    );

    const { isFinished, isBackoffice } = status;
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "payments.service.new",
        "Recargas",
        "refillsTransactionPage",
    );

    const handleDownload = async () => {
        await setShowMoreData(true);
        return handlePrint();
    };

    return (
        <>
            {isFinished && <Notification scopeToShow="refillsTransactionPage" />}
            {!isBackoffice && <ResponsiveHeader ticket id="refills.title" metaTitle="refills.title" />}

            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title="refills.title" />
                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <RefillsSummaryBody
                                        formData={transaction.data}
                                        isRecipt
                                        isSuccessRecipt={isFinished}
                                        isDesktop={isDesktop}
                                        setShowMoreData={setShowMoreData}
                                        showMoreData={showMoreData}
                                    />
                                    <div className="ticket__body ticket__full-width">
                                        {isFinished && (
                                            <div className="text-center">
                                                <div className="ticket__divider inside-ticket__body">
                                                    <div className="ticket__notch ticket__notch--left"> </div>
                                                    <div className="ticket__notch ticket__notch--right"> </div>
                                                </div>
                                                <Image src="images/figma/illustrations/rapipago.svg" />
                                            </div>
                                        )}
                                    </div>
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            <Col xs={12} md={4} mdOffset={2}>
                                {isFinished ? (
                                    <Button
                                        className="btn btn-outline"
                                        image="images/figma/icon/download.svg"
                                        label="global.download"
                                        onClick={handleDownload}
                                    />
                                ) : (
                                    <>
                                        {showSignButton && (
                                            <Button
                                                onClick={handleSignTransaction}
                                                label="forms.signTransaction.link"
                                                className="btn btn-primary"
                                            />
                                        )}
                                    </>
                                )}
                            </Col>
                            {isFinished && !isDesktop && (
                                <Col xs={12} md={4} mdOffset={2}>
                                    <Button
                                        className="btn btn-outline"
                                        image="images/figma/icon/share.svg"
                                        label="global.share"
                                        onClick={() => {
                                            handleShareMobile();
                                        }}
                                    />
                                </Col>
                            )}
                            {!isFinished && (
                                <Col xs={12} md={4} mdOffset={2}>
                                    <Button
                                        onClick={() => dispatch(push("/desktop"))}
                                        label="forms.transaction.ticket.actions.backToHome"
                                        className="btn btn-outline"
                                    />
                                </Col>
                            )}

                            <Col xs={12} md={4}>
                                <Button
                                    onClick={() => dispatch(push("/Payment/refills"))}
                                    label="recharges.new.recharge"
                                    className="btn btn-primary"
                                />
                            </Col>
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

RefillsTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default RefillsTransactionPage;
